/**
 * Gallery highlight card – matches Upcoming Events poster layout.
 */

import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImages } from '@fortawesome/free-solid-svg-icons';

const SLIDE_INTERVAL_MS = 4000;

function GalleryEventCard({ group, groupIndex, onOpenLightbox }) {
  const [slideIndex, setSlideIndex] = useState(0);
  const imageCount = group.images.length;
  const currentImage = group.images[slideIndex] || group.images[0];
  const detail = group.location || group.date || '';

  const openCard = () => onOpenLightbox(groupIndex, slideIndex);

  const handlePosterKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      openCard();
    }
  };

  useEffect(() => {
    setSlideIndex(0);
  }, [group.id]);

  useEffect(() => {
    if (imageCount <= 1) return undefined;

    const timer = window.setInterval(() => {
      setSlideIndex((prev) => (prev + 1) % imageCount);
    }, SLIDE_INTERVAL_MS);

    return () => window.clearInterval(timer);
  }, [imageCount, group.id]);

  return (
    <article className="gallery-highlight-card">
      <div
        className="gallery-highlight-poster"
        onClick={openCard}
        onKeyDown={handlePosterKeyDown}
        role="button"
        tabIndex={0}
        aria-label={`View photos for ${group.title}`}
      >
        <span className="gallery-highlight-poster-frame">
          <img
            key={currentImage.id}
            src={currentImage.url}
            alt=""
            className="gallery-highlight-image"
            loading="lazy"
          />
        </span>
        {imageCount > 1 && (
          <span className="gallery-highlight-count">
            <FontAwesomeIcon icon={faImages} />
            {imageCount}
          </span>
        )}
      </div>
      <h3 className="gallery-highlight-title" onClick={openCard}>
        {group.title}
      </h3>
      {detail && <p className="gallery-highlight-detail">{detail}</p>}
    </article>
  );
}

export function GalleryFeaturedSlideshow({ group }) {
  const [slideIndex, setSlideIndex] = useState(0);
  const imageCount = group.images.length;
  const currentImage = group.images[slideIndex] || group.images[0];

  useEffect(() => {
    setSlideIndex(0);
  }, [group.id]);

  useEffect(() => {
    if (imageCount <= 1) return undefined;

    const timer = window.setInterval(() => {
      setSlideIndex((prev) => (prev + 1) % imageCount);
    }, SLIDE_INTERVAL_MS);

    return () => window.clearInterval(timer);
  }, [imageCount, group.id]);

  return (
    <div className="gallery-featured-image-wrap">
      <img
        key={currentImage.id}
        src={currentImage.url}
        alt={group.title}
        className="gallery-featured-image"
        loading="eager"
      />
      {imageCount > 1 && (
        <span className="gallery-photo-count">
          <FontAwesomeIcon icon={faImages} />
          {imageCount} photos
        </span>
      )}
    </div>
  );
}

export default GalleryEventCard;
